import { css } from 'aphrodite';
import * as React from 'react';
import DisclosureDownIconUrl from '../../../assets/icon_downArrow.svg';
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '../../../components-v2/Collapsible';
import { s } from './styles';
import './styles.less';

interface IProps {
	className?: string;
	description?: React.ReactNode;
	expanded?: boolean;
	footer?: React.ReactNode;
	icon: React.ReactNode;
	name: React.ReactNode;
	onToggleExpansion?(expanded: boolean): void;
}

export const SettingsGroup: React.FC<React.PropsWithChildren<IProps>> = ({
	children,
	className,
	description,
	expanded,
	footer,
	icon,
	name,
	onToggleExpansion,
}) => {
	return (
		<Collapsible
			className={`${css(s.root)} settings-group ${expanded ? 'settings-group-expanded' : ''} ${className || ''}`}
			open={expanded}
			onOpenChange={onToggleExpansion}
		>
			<CollapsibleTrigger className={`settings-group-header ${css(s.header)}`}>
				<div className='settings-group-header-icon'>{icon}</div>
				<div className='settings-group-header-content'>
					<div className='settings-group-name'>{name}</div>
					{!!description && <div className='settings-group-description'>{description}</div>}
				</div>
				<span className='settings-group-header-disclosure'>
					<img src={DisclosureDownIconUrl} />
				</span>
			</CollapsibleTrigger>
			<CollapsiblePanel>
				<div className='settings-group-body-content'>
					{children}
					{footer && <footer className='settings-group-footer'>{footer}</footer>}
				</div>
			</CollapsiblePanel>
		</Collapsible>
	);
};
